import { Modal } from '@zillow/constellation-10';
import TenantPlacementUpsell from '../AddPropertyModal/components/TenantPlacementUpsell';

const TenantPlacementUpsellModal = ({
  onClose,
  onPostListingClick,
}: {
  onClose: () => void;
  onPostListingClick: () => void;
}) => {
  return (
    <Modal open={true} size={{ base: 'fullScreen', md: 'lg' }} onOpenChange={(open) => !open && onClose()}>
      <TenantPlacementUpsell isInReactivationFlow={true} onPostListingClick={onPostListingClick} />
    </Modal>
  );
};

export default TenantPlacementUpsellModal;
